import styled from '@emotion/styled';
import { Button } from '@presentation/components';

export const FileContentWrapper = styled.div`
  position: relative;
  border-radius: 12px;
  padding: 6px;
  filter: drop-shadow(0px 0px 14px rgba(0, 0, 0, 0.08));
  background: ${(props) => props.theme.color.light.default};
  text-align: center;
  &:hover {
    background: ${(props) => props.theme.color.light.tintDarker};
  }
  text-align: center;
`;

export const ImageFile = styled.img`
  max-width: 200px;
  max-height: 200px;
  object-fit: cover;
  cursor: pointer;
`;

export const File = styled(Button)`
  height: auto;
  white-space: normal;
  background: none;
`;
